import { isEmpty, isUndefined, omitBy } from "lodash-es";
import { useMemo } from "react";
import { useFinanceEntries } from "web_myplann/Finances/Hooks/useFinanceEntries";
import { useInspirationJourney } from "web_myplann/Inspiration/Hooks/useInspirationJourney";
import { useOwnHomeContext } from "web_myplann/Inspiration/OwnHome/Hooks/useOwnHomeContext";
import { mapBalanceToOwnHomeInputs } from "web_myplann/Inspiration/OwnHome/Mappers/mapBalanceToOwnHomeInputs";
import type { OwnHomeInputs } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";

export type OwnHomeSheet = "quick" | "expenses" | "affordability-edit";

export const useOwnHomeJourney = () => {
	const {
		expenseEntries,
		totalIncome,
		totalExpenses,
		isLoading: isBalanceLoading,
	} = useFinanceEntries();
	const {
		inputs: overrides,
		submitInputs,
		...journey
	} = useInspirationJourney<OwnHomeInputs, OwnHomeSheet>({});

	const inputs = useMemo(
		() => ({
			...mapBalanceToOwnHomeInputs({
				expenseEntries,
				totalIncome,
				totalExpenses,
			}),
			...overrides,
		}),
		[expenseEntries, totalIncome, totalExpenses, overrides],
	);

	const { context, isLoading: isRatesLoading } = useOwnHomeContext(inputs);

	return {
		...journey,
		inputs,
		hasEnteredValues: !isEmpty(overrides),
		context,
		isLoading: isBalanceLoading || isRatesLoading,
		submitInputs: (patch: OwnHomeInputs) =>
			submitInputs(omitBy(patch, isUndefined)),
	};
};
